import _ from 'lodash';
import clientId from 'clientId';

export default function() {
  const index = {
    spop: {
      favicon: require('./favicon/spop.ico'),
      title: '易研網上信息閱讀平台 sPOP',
    },
    umacspop: {
      favicon: require('./favicon/umacspop.ico'),
      title: '易研網上信息閱讀平台 sPOP',
    },
    hkspop: {
      favicon: require('./favicon/hkspop.ico'),
      title: '源大網上信息閱讀平台 sPOP',
    }
  };
  if (window.location.host.split('.')[0] == "spop-umac") {
    return index["umacspop"];
  } else {
    return index[clientId];
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/customization/createCustomization.js
 **/